import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./past-shows.module.css";

const PastShows = () => (
  <section id="past-shows" className="section-wrapper">
    <h2 className="section-title">
      <a href="#past-shows">Past Shows</a>
    </h2>
    <div className={styles.pastShowsWrapper}>
      <StaticImage
        src="../../images/past-shows/1_high_exposure_tour.png"
        alt="High Exposure Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/2_electric_imprint_takeover.png"
        alt="Electric Imprint Takeover Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/3_groozeshipp.png"
        alt="Groozeshipp Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/4_funked_up.png"
        alt="Funked Up Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/5_firelights.png"
        alt="Firelights Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/6_dream-sequence.png"
        alt="Dream Sequence Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/7_sin-night.png"
        alt="Sin Night Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/8_monday-mood.png"
        alt="Monday Mood Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/9_so-down-charleston.jpg"
        alt="So Down Charleston Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/10_daily-bread.jpg"
        alt="Daily Bread Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/11_summit-sessions.jpg"
        alt="Summit Sessions Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/12_marvel-years.jpg"
        alt="Marvel Years Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/13_so-down-charlotte.jpg"
        alt="So Down Charlotte Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/14_clubhouse-s6.jpg"
        alt="Clubhouse S6 Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />

      <StaticImage
        src="../../images/past-shows/15_butterfleyes.jpg"
        alt="Butterfleyes Flyer"
        placeholder="blurred"
        className={styles.pastShowImageItem}
      />
    </div>
  </section>
);

export default PastShows;
